<div class="main-container">
  <div class="left-container">
    <div class="d-flex justify-content-center align-items-center flex-column">
      <div>
        <ng-container *ngIf="userImage; else defaultAvatar">
          <img
            [src]="userImage"
            alt="User Avatar"
            width="94"
            height="96"
            style="border-radius: 50%; object-fit: cover"
          />
        </ng-container>
        <ng-template #defaultAvatar>
          <svg
            width="94"
            height="96"
            viewBox="0 0 94 96"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M94 48C94 74.5097 72.9574 96 47 96C21.0426 96 0 74.5097 0 48C0 21.4903 21.0426 0 47 0C72.9574 0 94 21.4903 94 48Z"
              fill="#B3E4E1"
            />
            <path
              d="M17.3538 85.2485C19.8972 72.4652 32.2029 62.7692 47 62.7692C61.7971 62.7692 74.1027 72.4652 76.6462 85.2485C68.5587 91.9704 58.2401 96 47 96C35.7599 96 25.4413 91.9704 17.3538 85.2485Z"
              fill="white"
            />
            <path
              d="M61.4615 41.5385C61.4615 49.8652 54.852 56.6154 46.6987 56.6154C38.5454 56.6154 31.9359 49.8652 31.9359 41.5385C31.9359 33.2117 38.5454 26.4615 46.6987 26.4615C54.852 26.4615 61.4615 33.2117 61.4615 41.5385Z"
              fill="white"
            />
          </svg>
        </ng-template>
      </div>
      <div class="name">{{ patientName }}</div>
      <div class="clinic">{{ clinicName }}</div>
    </div>
    <div class="timer">{{ formattedTime }}</div>
    <div class="right-call-div">
      <div class="user-container" *ngIf="mute">
        <i class="ti ti-microphone"></i>
        {{ userName }}'s microphone is on
      </div>

      <div class="user-container" *ngIf="!mute">
        <i class="ti ti-microphone-off"></i>
        {{ userName }}'s microphone is off
      </div>

      <div class="call-btns">
        <div class="call-btn">
          <!-- <div class="circle-btn"><i class="ti ti-volume"></i></div>

          <span>Record Call</span> -->
        </div>

        <div class="call-btn">
          <div class="circle-btn halo mute" (click)="toggleMic()">
            <i class="ti" [ngClass]="mute ? 'ti-microphone' : 'ti-microphone-off'"></i>
          </div>
          <span>{{ mute ? "Mute" : "Unmute" }}</span>
        </div>

        <div class="call-btn">
          <div class="circle-btn end" (click)="endcall()">
            <svg
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_11253_10930)">
                <path
                  d="M3.95909 10.5546L5.32273 9.47047C5.65 9.21138 5.84091 8.81592 5.84091 8.40001V6.62729C7.9 5.9591 10.1295 5.95229 12.1955 6.62729V8.40683C12.1955 8.82274 12.3864 9.21819 12.7136 9.47728L14.0705 10.5546C14.6159 10.9841 15.3932 10.9432 15.8841 10.4523L16.7159 9.62047C17.2614 9.07501 17.2614 8.16819 16.6818 7.65683C12.3114 3.79774 5.725 3.79774 1.35454 7.65683C0.774999 8.16819 0.774999 9.07501 1.32045 9.62047L2.15227 10.4523C2.63636 10.9432 3.41364 10.9841 3.95909 10.5546V10.5546Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_11253_10930">
                  <rect
                    width="16.3636"
                    height="16.3636"
                    fill="white"
                    transform="translate(0.884277)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <span>Hang Up</span>
        </div>
      </div>
    </div>
  </div>
  <div class="right-container" *ngIf="showKeypad">
    <app-keypad
      (clickEvent)="handleKeypadEvent($event)"
      [callActive]="isOnCall"
      [disabled]="!isOnCall"
      [showCallBtn]="false"
    />
  </div>
</div>
